<template>
  <div id="preview" class="m-2 m-md-4 py-2 preview">
    <div class="mb-3" :style="[allStudentShow ? { maxHeight: 'none' } : { maxHeight: '145px' }, { overflow: 'hidden' }]">
      <K2Row :space-between="true" :styles="{ width: '100%' }">
        <K2Text bold="true">{{ lang('Showing To') }}</K2Text>
        <K2Button size="mini" v-if="allStudentShow" @onclick="handleStudentShow()">{{ lang('Show Less') }}</K2Button>
        <K2Button size="mini" v-else @onclick="handleStudentShow()">{{ lang('Show All') }}</K2Button>
      </K2Row>
      <K2Row v-if="passSchool">
        <K2Row justify_content="center" align="center" class="box error me-2 mt-2 rounded-pill px-3 px-md-2 py-1" v-if="passSchool">
          <K2Text color="white">{{ passSchool }}</K2Text>
        </K2Row>
      </K2Row>
      <K2Row class="flex-wrap" v-else-if="passmselectedlevels && passmselectedlevels.length > 0" :styles="{ flexWrap: 'wrap' }">
        <K2Row
          justify_content="center"
          align="center"
          v-for="(level, i) in passmselectedlevels"
          :key="i"
          class="box blue me-2 mt-2 rounded-pill px-3 px-md-2 py-1"
        >
          <K2Text color="white">{{ level.Str_Display || level.PostTagLevelName }}</K2Text>
        </K2Row>
      </K2Row>
      <K2Row v-else-if="passmseelctedclasses && passmseelctedclasses.length > 0" :styles="{ flexWrap: 'wrap' }">
        <K2Row
          justify_content="center"
          align="center"
          v-for="(classes, i) in passmseelctedclasses"
          :key="i"
          class="box yellow me-2 mt-2 rounded-pill px-3 px-md-2 py-1"
        >
          <K2Text>{{ classes.Str_Display || classes.PostTagClassName }} {{ classes.PostTagClassBatch }}</K2Text>
        </K2Row>
      </K2Row>
      <K2Row v-else-if="passmselectedstudents && passmselectedstudents.length > 0" :styles="{ flexWrap: 'wrap' }">
        <K2Row
          justify_content="center"
          align="center"
          v-for="(student, i) in passmselectedstudents"
          :key="student.PostTagUserID + i"
          class="box purple me-2 mt-2 rounded-pill px-3 px-md-2 py-1"
        >
          <K2Text :color="uiVariable.color.purple">{{ student.StudentName || student.First_Name }}</K2Text>
        </K2Row>
      </K2Row>
    </div>
    <K2Carousel :slide-list="passselectedfile" v-if="passselectedfile && passselectedfile.length" />
    <div class="my-3">
      <K2Text bold="true">{{ lang('Content') }}:</K2Text>
      <br />
      <span v-html="passtaparent" />
      <div class="mb-3" v-if="passkeytags">
        <K2Text bold="true">{{ lang('Tags') }}:</K2Text>
        <K2Row class="flex-wrap" v-if="isPublished">
          <K2Row
            justify_content="center"
            align="center"
            v-for="tag in passkeytags"
            :key="tag.PostKeyTagPostID"
            class="box purple me-2 mt-2 rounded-pill px-2 py-1"
          >
            <K2Text :color="uiVariable.color.purple">{{ tag.PostKeyTagValue }}</K2Text>
          </K2Row>
        </K2Row>
        <K2Row class="flex-wrap" v-else>
          <K2Row justify_content="center" align="center" v-for="tag in passkeytags" :key="tag.KeyTag" class="box purple me-2 mt-2 rounded-pill px-2 py-1">
            <K2Text :color="uiVariable.color.purple">{{ tag.KeyTag }}</K2Text>
          </K2Row>
        </K2Row>
      </div>

      <K2Row>
        <div class="me-2">
          <K2Text bold="true" v-if="parentPost && parentPost.PostIsUpdated">{{ lang('Modified on') }}:</K2Text>
          <K2Text bold="true" v-else>{{ lang('Created On') }}:</K2Text>
          <K2Text :color="uiVariable.color.purple" v-if="isPublished">
            {{ moment(createdDate).format('DD/MM/YYYY [&nbsp;] HH:mm') }}
          </K2Text>
          <K2Text :color="uiVariable.color.purple" v-else>
            {{ moment(new Date()).format('DD/MM/YYYY [&nbsp;] HH:mm') }}
          </K2Text>
        </div>
        <div>
          <K2Text bold="true">{{ lang('Post Type') }}:</K2Text>
          <K2Text :color="uiVariable.color.purple" v-if="isBroadcast"> Broadcast</K2Text>
          <K2Text :color="uiVariable.color.purple" v-else> {{ postType }}</K2Text>
        </div>
      </K2Row>

      <div class="box purple p-3 rounded-3 mt-3" v-if="passdevelopmentgoals && passdevelopmentgoals.length > 0">
        <!--        {{passdevelopmentgoals}}-->
        <K2Text bold="true" :color="uiVariable.color.purple" class="mb-2 d-block">{{ lang('Learning Goals') }} ({{ lang('Indicator') }})</K2Text>
        <div v-if="isPublished">
          <K2Row v-for="item of passdevelopmentgoals" :key="item.PostUpLMID" class="mb-2">
            <K2Icon name="check_circle" :color="uiVariable.color.purple" font-size="16px" class="mt-1 me-2" />
            <K2Text>{{ item.PostUpLMIndicator }}</K2Text>
          </K2Row>
        </div>
        <div v-else>
          <K2Row v-for="item of passdevelopmentgoals" :key="item.KeyId" class="mb-2">
            <K2Icon name="check_circle" :color="uiVariable.color.purple" font-size="16px" class="mt-1 me-2" />
            <K2Text>{{ item.Indicator }}</K2Text>
          </K2Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uiVariable from '../../../config/uiVariable'
import K2Carousel from '../../../uiComponents/k2Carousel/k2Carousel'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import moment from 'moment'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Icon from '../../../uiComponents/k2Icon/k2MAIcon'
import K2Button from '../../../uiComponents/k2Button/k2Button'
import { lang } from '../../../locale/index'

export default {
  name: 'activityPreview',
  props: [
    'passselectedfile',
    'passtaparent',
    'passdevelopmentgoals',
    'isPublished',
    'createdDate',
    'passmseelctedclasses',
    'passmselectedlevels',
    'passmisallclasses',
    'passmselectedstudents',
    'passkeytags',
    'postType',
    'passSchool',
    'parentPost',
    'isBroadcast',
  ],
  components: { K2Button, K2Icon, K2Row, K2Text, K2Carousel },
  data() {
    return {
      uiVariable: uiVariable,
      moment: moment,
      allStudentShow: false,
    }
  },
  created() {},
  mounted() {
    console.log(this.parentPost, 'preview')
  },
  methods: {
    lang,
    onSlideStart(slide) {
      this.sliding = true
    },
    handleStudentShow() {
      this.allStudentShow = !this.allStudentShow
    },
  },
}
</script>
